import {Component, OnInit}          from "@angular/core";
import {Api}                        from "../../shared/api.service";
import {MessageStatistics}          from "../../shared/api/messages/api.models";
import {Utils}                      from "../../shared/utils.service";
import {Pagination}                 from "../../shared/api/pagination.interface";
import {Message, MessageCollection} from "../../shared/api/messages/api.models";
import {ModalService}               from '../../shared/modal.service';
import {MessageModal}               from '../../messages/components/message.modal';
import {Permission}                 from '../../shared/api/permissions/api.models';
import {AuthenticationService}      from "../../shared/authentication.service";
import {Router, ActivatedRoute}     from "@angular/router";
import {GroupedBase}                from '../../shared/resolvers/bases.resolver';

class MessageStatisticRow {
    name:                string;
    sent:                number = 0;
    replies:             number = 0;
    conversion:          number = 0;
    total:               number = 0;
    messageCollectionId: number = null;
    baseNames:           string = '';
    type:                string = '';
    category:            string = '';
}

class messageTags {
    label:  string;
    tag:    string;
}

class messageTypes {
    label:  string;
    tag:    string;
}

class Bases {
    label:  string;
    base:   string;
}

class AvailableFilters {
    sent:                number[] = [];
    repliedPaid:         number[] = [];
    messageCollectionId: number[] = [];
    conversion:          number[] = [];
    messageTags:         string[] = [];
    messageTypes:        string[] = [];
    languages:           number[] = [];
}

class ExportRange {
    startPage: number = 1;
    endPage: any   = 'all';
}

@Component({
    selector:   'statistics-message-stats',
    template:require('./messageStats.component.html'),
    styles:  [require('./messageStats.component.scss')]
})

export class messageStatsComponent implements OnInit {

    protected tags:                 string[]              = MessageCollection.tags;
    protected messageOptions:       string[]              = Message.types;
    protected messageCollection:    MessageCollection[]   = [];
    protected rows:                 MessageStatisticRow[] = [];
    protected rowTotal:             MessageStatisticRow   = new MessageStatisticRow();
    protected rowHash:              any                   = {};
    protected expRows:              MessageStatisticRow[] = [];
    protected expRowTotal:          MessageStatisticRow   = new MessageStatisticRow();
    protected expHash:              any                   = {};
    protected isLoading:            boolean               = false;
    protected filters:              any;

    protected exportRange:          ExportRange           = new ExportRange();
    protected exportCall:           boolean               = false;
    protected exportError:          string                = '';

    protected messages:             MessageStatistics[]   = [];
    protected messageTags:          messageTags[]         = [];
    protected messageTypes:         messageTypes[]        = [];
    protected baseNames:            Bases[]               = [];
    protected bases:                GroupedBase[]         = [];

    protected sortColumn:           string    = null;
    protected sortDirection:        string    = null;
    protected orderBy:              string    = 'repliedPaid';
    protected sort:                 string    = 'desc';

    protected currentPage:          number;
    protected perPage:              number = 20;
    protected collectionSize:       number;
    protected exportSize:           number;

    static readonly GROUP_BY_ID               = 'Id';
    static readonly GROUP_BY_BASE             = 'Basename';

    static readonly SORT_ASC                  = 'ASC';
    static readonly SORT_DESC                 = 'DESC';

    protected readonly groupBys: string[] = [
        messageStatsComponent.GROUP_BY_ID,
        messageStatsComponent.GROUP_BY_BASE
    ];

    protected columns:      any = {
        sent        : true,
        replies     : true,
        conversion  : true,
        baseNames   : true,
        total       : true,
        type        : true,
        category    : true,
    };

    constructor(private route: ActivatedRoute, private api: Api, private router: Router, private utils: Utils, private modal: ModalService, private auth: AuthenticationService) {}

    ngOnInit() {
        this.bases = this.route.snapshot.data['bases'];
        this.resetFilters();
        this.reload(1);
    }

    protected resetFilters(reload: boolean = false) {
        this.filters = {
            groupBy: messageStatsComponent.GROUP_BY_ID,
            baseNames: null,
            tag: null,
            type: null,
            isMutated: false
        };

        if (reload === true) {
            this.reload(this.currentPage, false);
        }
    }

    showMessageCollection(rowData) {
        this.api.messages().resourceWithDetails(rowData.messageCollectionId).subscribe(
            (messageCollection: MessageCollection) => {
                let modal = this.modal.custom(MessageModal);
                modal.componentInstance.showRemoveButton  = this.auth.canDoAny([Permission.MESSAGES_DELETE]);
                modal.componentInstance.showEditButton    = this.auth.canDoAny([Permission.MESSAGES_EDIT_MESSAGES]);
                modal.componentInstance.messageCollection = messageCollection;
                modal.result.then(
                    () => {
                        this.modal.confirm(
                            "Remove message",
                            "Are you sure you want to remove this message?"
                        ).then(
                            () => {
                                this.api.messages().remove(rowData.messageCollectionId).subscribe(
                                    () => {
                                        this.reload(this.currentPage);
                                    }
                                );
                            },
                        );
                    },
                    (dismissData) => {
                        if (dismissData && dismissData.type === 'edit') {
                            this.router.navigate(['/messages/edit'], { queryParams : { messageId : dismissData.messageId }});
                        }
                    }
                );
            }
        )
    }

    protected sortRows() {
        if (this.sortColumn === null) {
            return;
        }

        this.rows.sort((a: MessageStatisticRow, b: MessageStatisticRow) => {
            if (a[this.sortColumn] < b[this.sortColumn]) {
                return this.sortDirection === messageStatsComponent.SORT_ASC ? -1 : 1;
            } else if (a[this.sortColumn] > b[this.sortColumn]) {
                return this.sortDirection === messageStatsComponent.SORT_ASC ? 1 : -1;
            }

            return 0;
        });
    }

    protected toggleSort(column: string) {
        if (column === 'sent' || column === 'repliedPaid' || column === 'conversionRatio') {
            const desc = messageStatsComponent.SORT_DESC.toLocaleLowerCase();
            const asc = messageStatsComponent.SORT_ASC.toLocaleLowerCase();
            this.orderBy = column;
            if (this.sort === null) {
                this.sort = asc;
            } else {
                this.sort = (this.sort === asc) ?
                desc :
                asc;
            }

            this.sort = this.sort.toLowerCase()
            this.reload(1, false)
            return;
        }

        if (column !== this.sortColumn) {
            this.sortColumn    = column;
            this.sortDirection = messageStatsComponent.SORT_ASC;

            return this.sortRows();
        }

        if (this.sortDirection === null) {
            this.sortDirection = messageStatsComponent.SORT_ASC;
        } else {
            this.sortDirection = (this.sortDirection === messageStatsComponent.SORT_DESC) ?
                messageStatsComponent.SORT_ASC :
                messageStatsComponent.SORT_DESC;
        }

        return this.sortRows();
    }

    private createFilterOptions(availableFilters: AvailableFilters) {
        this.messageTypes   = [];
        this.messageTags    = [];
        this.baseNames      = [];

        this.bases.forEach((item) => {
            const exists = this.baseNames.findIndex(geoLabel => geoLabel.label === item.name );

            if (exists === -1) {
                this.baseNames.push({
                    label: item.name,
                    base: item.name
                })
            }
        })

        this.utils.sortList(this.baseNames, 'label');

        this.tags.forEach((filter: string) => {
            this.messageTags.push({
                label: filter,
                tag  : filter
            });

            if (this.filters.tag && this.filters.tag.label === filter) {
                this.filters.tag = this.messageTags[this.messageTags.length - 1];
            }
        });

        this.utils.sortList(this.messageTags, 'label');

        this.messageOptions.forEach((filter: string) => {
            this.messageTypes.push({
                label: filter,
                tag  : filter
            });

            if (this.filters.type && this.filters.type.label === filter) {
                this.filters.type = this.messageTypes[this.messageTypes.length - 1];
            }
        });

        this.utils.sortList(this.messageTypes, 'label');

    }

    // which persentage is x of y
    // 5 paid replies, 10 times sent
    // 5:x / 10:y * 100 = 50%
    calculateRatio(x: number, y:number) {
        // times 10000 because we want to show 2 decimals and a % number
        // + 0.00001 for floating point numbers
        return Math.round((( x / y ) + 0.00001) * 10000) / 100;
    }

    private populateStatisticTable(reloadFilters: boolean): void {
        let availableFilters = new AvailableFilters();

        if (this.exportCall) {
            this.expRows          = [];
            this.expHash       = {};
            this.expRowTotal      = new MessageStatisticRow();
            this.expRowTotal.name = 'Total';
        } else {
            this.rows          = [];
            this.rowHash       = {};
            this.rowTotal      = new MessageStatisticRow();
            this.rowTotal.name = 'Total';
        }

        let groupField: (log: MessageStatistics) => any;
        let groupLabel: (log: MessageStatistics) => any;

        switch (this.filters.groupBy) {
            case messageStatsComponent.GROUP_BY_ID:
            groupField = (log: MessageStatistics) => log.messageCollectionId;
            groupLabel = (log: MessageStatistics) => log.messageCollectionId;
            break;
            case messageStatsComponent.GROUP_BY_BASE:
            break;
        }

        this.messages.forEach((log: MessageStatistics) => {

            if (this.filters.baseNames !== null && (!log.baseName || log.baseName.indexOf(this.filters.baseNames) === -1)) {
                return;
            }

            let hashKey = groupField(log);
            if (this.rowHash[hashKey] === undefined || this.exportCall) {
                let row                 = new MessageStatisticRow();
                row.name                = groupLabel(log);
                row.sent                = log.sent;
                row.replies             = log.repliedPaid;
                row.sent                = log.sent;
                row.messageCollectionId = log.messageCollectionId;
                row.baseNames           = log.baseName;
                row.type                = log.type;
                row.category            = log.tag;
                row.conversion          = log.conversionRatio;

                if (this.exportCall) {
                    this.expRows.push(row);
                    this.expHash[hashKey] = row;

                    this.expRowTotal.sent += log.sent;
                    this.expRowTotal.replies += log.repliedPaid;

                    if (this.expRowTotal.replies && this.expRowTotal.sent) {
                        const avrgconversion = this.calculateRatio(this.expRowTotal.replies, this.expRowTotal.sent);
                        this.expRowTotal.conversion = avrgconversion;
                    }
                } else {
                    this.rows.push(row);
                    this.rowHash[hashKey] = row;

                    this.rowTotal.sent += log.sent;
                    this.rowTotal.replies += log.repliedPaid;

                    if (this.rowTotal.replies && this.rowTotal.sent) {
                        const avrgconversion = this.calculateRatio(this.rowTotal.replies, this.rowTotal.sent);
                        this.rowTotal.conversion = avrgconversion;
                    }
                }
            }
        });

        this.sortRows();

        if (reloadFilters === true) {
            this.createFilterOptions(availableFilters);
        }

        this.isLoading  = false;
    }

    filtersMutated(reloadFilters: boolean = true) {
        this.filters.isMutated = true;
        this.reload(this.currentPage, reloadFilters);
    }

    reload(page: number, reloadFilters: boolean = true) {
        if (!page) {
            this.currentPage = 1;
        }
        this.currentPage = page;

        // clear the current messages
        // e.g.: pagination asks new page
        // new data WILL be fetched
        // but angular does not see an update
        // because the build up of the new data is the same
        this.messages = [];
        if (this.filters.isMutated === false) {
            this.resetFilters();
        }
        this.loadData([], reloadFilters, false);
    }

    public exportData() {
        const type = this.filters.type;
        const tag = this.filters.tag;
        const baseName = this.filters.baseNames;

        let perPage = this.perPage;

        if (
            // if endpage is not string all AND is not a number
            this.exportRange.endPage !== 'all' && isNaN(this.exportRange.endPage)
            // OR if start page is not a number
            || isNaN(this.exportRange.startPage)
            // OR if the startpages number is smaller than the end page
            || this.exportRange.endPage < this.exportRange.startPage
        ) {
            this.exportError = 'Something is wrong with your page range selection';
            return;
        } else {
            this.exportError = '';
        }

        if (this.exportRange.endPage === 'all') {
            perPage = this.collectionSize;
        } else {
            const endPage = this.exportRange.endPage;
            perPage = (this.perPage * endPage);

            if (perPage === 0) {
                perPage = this.perPage;
            }
        }

        let currentPage = this.exportRange['startPage'];

        this.api.messages().MessageStatisticsExport(
                type,
                tag,
                baseName,
                this.orderBy,
                this.sort,
                currentPage,
                perPage,
        ).subscribe((response: any) => {
            let date = new Date();
            const blob = new Blob([response.text()], { type: 'text/csv' });
            if (blob) {
                this.exportError = '';
                const url = window.URL.createObjectURL(blob);
                let anchor = document.createElement("a");
                anchor.download = 'export_' + date.getFullYear() + '-' + date.getMonth() + '-' +  date.getDay() + '.csv';
                anchor.href = url;
                anchor.click();
            } else {
                this.exportError = 'Something went wrong while getting your csv, please contact developers'
            }
        })
    }

    private loadData(messages: MessageStatistics[] = [], reloadFilters: boolean, exportCall: boolean) {
        this.exportCall = exportCall;
        let perPage = this.perPage;
        let currentPage = this.currentPage

        if (exportCall) {

            if (
                // if endpage is not string all AND is not a number
                this.exportRange.endPage !== 'all' && isNaN(this.exportRange.endPage)
                // OR if start page is not a number
                || isNaN(this.exportRange.startPage)
                // OR if the startpages number is smaller than the end page
                || this.exportRange.endPage < this.exportRange.startPage
            ) {
                this.exportError = 'Something is wrong with your page range selection';
                return;
            } else {
                this.exportError = '';
            }

            if (this.exportRange.endPage === 'all') {
                perPage = this.collectionSize;
            } else {
                const startPage = this.exportRange.startPage;
                const endPage = this.exportRange.endPage;
                perPage = (this.perPage * (endPage - startPage));

                if (perPage === 0) {
                    perPage = this.perPage;
                }
            }

            currentPage = this.exportRange['startPage'];
        }
        const type = this.filters.type;
        const tag = this.filters.tag;
        const baseName = this.filters.baseNames;

        // 5000 is a random perPage number
        // page = 1 and is set in the reload function
        // after that it is updating itself in the subscripe method below
        // in this way all available data is loaded once on 1 page
        // Now the export csv can have all data instead of data per page
        this.api.messages().MessageStatistics(
            type,
            tag,
            baseName,
            this.orderBy,
            this.sort,
            currentPage,
            perPage,
        ).subscribe((response: any) => {
            this.messages = response.result

            this.populateStatisticTable(reloadFilters);
            this.setPagination(response.pagination);
        })
    }

    private setPagination(pagination: Pagination) {
        this.exportSize = pagination.total
        if (!this.exportCall) {
            this.currentPage    = pagination.current;
            this.collectionSize = pagination.total;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/statistics/messagesStatistics/messageStats.component.ts